import DOMPurify from "dompurify";
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { EmailPreviewData, useEmailPreview } from "./useEmailPreview";

export interface TicketSubmitConfirmModalProps {
  isShow: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  emailPreviewData: EmailPreviewData;
}

export const TicketSubmitConfirmModal: React.FC<
  TicketSubmitConfirmModalProps
> = ({ isShow, onConfirm, onCancel, emailPreviewData }) => {
  const { error, preview, fetchPreview } = useEmailPreview(emailPreviewData);
  const modalRoot = document.getElementById("modal-root");

  useEffect(() => {
    if (isShow && emailPreviewData) {
      fetchPreview();
    }
  }, [isShow, emailPreviewData, fetchPreview]);

  return modalRoot && isShow
    ? createPortal(
        <div className="modal ticket-submit-confirm-modal">
          <div className="modal-content">
            {/* メールプレビューセクション */}
            <div className="email-preview-section">
              <h3>送信予定のメール内容</h3>
              {error && (
                <div className="email-preview-error">
                  {error}
                  <br />
                  <small>※プレビューが表示できませんが、送信は可能です</small>
                </div>
              )}
              {preview && (
                <>
                  {/* 件名表示は一時的に非表示
              <div className="email-preview-subject">
                件名: {preview.subject}
              </div>
              <div className="email-preview-divider"></div>
              */}
                  <div
                    className="email-preview-content"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(preview.html),
                    }}
                  />
                </>
              )}
            </div>

            {/* 送信確認セクション */}
            <div className="modal-text">
              コメントを送信してよろしいでしょうか？
            </div>
            <div className="modal-buttons">
              <button
                className="uk-button--m uk-button-cancel"
                onClick={onCancel}
              >
                キャンセル
              </button>
              <button
                className="uk-button--m uk-button-refer uk-margin-left"
                onClick={onConfirm}
              >
                送信
              </button>
            </div>
          </div>
        </div>,
        modalRoot
      )
    : null;
};
